import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';

export default extend(dialog, {
	namespaced: true,
	state: {
		form: {
			name: '',
			phoneCountry: 'US',
			phone: '',
			email: ''
		},
	},
	actions: {
		async afterOpenDialog({ dispatch, commit }, payload) {
			commit('save', {
				form: {
					name: '',
					phoneCountry: 'US',
					phone: '',
					email: ''
				}
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/cs/consumer/create.js